<template>
  <wrap width="45%" :title="title" :minHeight="true" ref="wrap">

    <div class="order_temp_1">
      <div style="margin-bottom:5px" v-if="hasClass4">
        <span class="label">已选号码:</span>
        <span>{{numbers}}；组合如下：</span>
      </div>

      <div class="table">
        <c-table type="small" :head="head" :body="orders">
          <template slot="confirm" slot-scope="{data}">
            <input type="checkbox" :value="data.id" v-model="selected">
          </template>

          <template slot="detail_n" slot-scope="{data}">
            <span v-if="data.class4">{{data.class4}}</span>
            <span v-else>{{data.class2}} {{data.class3}}</span>
          </template>
        </c-table>
      </div>

      <div class="desc">
        <span class="label">组数：</span>
        <span class="tc" style="margin-right: 80px;">{{selected.length}}</span>

        <span class="text">总金额：</span>
        <span class="tc">{{total_money}}</span>
      </div>

      <div class="event">
        <event tag="button" @click="handle_submit" :disabled="order_subing" class="t_btn-d active">
          <span v-if="!order_subing">确定</span>
          <span v-else>提交中...</span>
        </event>
        <event tag="button" @click="hide" class="t_btn-d">取消</event>
      </div>

    </div>

  </wrap>
</template>

<script>
  import Wrap from './wrap';
  import cTable from './table';
   import  Vue from "../../utils/bus"
  export default {
    name: "order",
    components: {Wrap, cTable},
    props: {
      title: {
        type: String,
        default: '确认订单'
      },
      orders: {
        type: Array,
        default: () => ([])
      },
      order_subing: {
        type: Boolean
      }
    },
    watch: {
      orders: {
        deep: true,
        handler() {
          this.selected = this.orders.map(item => item.id);
        }
      }
    },
    computed: {
      list() {
        return this.orders.filter(item => this.selected.find(id => id === item.id));
      },
      total_money() {
        return this.list.map(item => parseFloat(item.value)).reduce((total, num) => {
          return total + num;
        }, 0);
      },
      numbers(){
        if(this.orders.length>0)
        return this.orders[0].class3||'';
        else return '';
      },
      hasClass4(){
        if(this.orders.length>0 && this.orders[0].class4==undefined){
        return false;}
        else {return true};
      },
      curTab(){
        if(this.orders.length>0){
          if(this.orders[0].class2=="特肖"){
            return '';
          }
          return this.orders[0].class1||'';
        }
        else return '';
      },
      head() {
          if(this.curTab=="连码"||this.curTab=="特肖合肖"||this.curTab=="连肖"||this.curTab=="连尾"||this.curTab=="自选不中"||this.curTab=="中一"||this.curTab=="特平中"){
            return [
              {
                label: '号码',
                value: 'detail_n'
              },
              {
                label: '赔率',
                value: 'odds'
              },
              {
                label: '金额',
                value: 'value'
              }
            ];
          }else{
            return [
              {
                label: '号码',
                value: 'detail_n'
              },
              {
                label: '赔率',
                value: 'odds'
              },
              {
                label: '金额',
                value: 'value'
              },
              {
                label: '确认',
                value: 'confirm'
              }
            ];
          }
      }
    },
    data() {
      return {
        selected: [],
        showOrderDialog:false
      };
    },

    mounted() {
    },
    methods: {
      async handle_submit() {
        if (this.list.length < 1) return this.$Message.error('请最少选择一注');

        try {
          this.$emit('submit', this.list.map(item => {
            return {
              ...item,
              money: parseFloat(item.value)
            };
          }));
        }catch (error) {
          console.error('提交失败:', error);
        } finally {
          // 无论成功与否，最终都要恢复按钮状态
         // this.isSubmitting = false;
        }
      },
      show() {
        this.selected = this.orders.map(item => item.id);
        this.$refs.wrap.show();
        this.showOrderDialog = true;
      },
      hide() {
        this.$refs.wrap.hide();
         // Vue.$emit("resetInput");
        this.showOrderDialog = false;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .order_temp_1 {
    /****
    .total {
      overflow: hidden;
      padding: 8px 0px;
      margin: 10px 0px;
      border: solid 1px #e6e6e6;
      position: relative;

      &:after {
        content: '';
        position: absolute;
        left: 50%;
        top: 0px;
        height: 100%;
        width: 1px;
        background: #e6e6e6;
      }

      li {
        float: left;
        width: 50%;
        text-indent: 10px;

        span {
          color: #ff6b6b;
        }
      }
    }

    .form {
      text-align: center;
      font-size: 0px;

      button {
        font-size: 12px;
        color: #ffffff;
        vertical-align top;
        border: none;
        padding: 6px 10px;
        border-radius: 3px;

        &.cancel {
          margin-left: 12px;
          background: #ff6b6b;
        }
      }
    }
     */

    mark {
      color red !important
      background transparent !important
    }

    input {
      height 28px
      outline nono
      border 1px solid #e6e6e6
    }

    .table {
      max-height 300px
      overflow-y scroll
      overflow-x hidden

      .table-item {
        width 100px
        display inline-block
        text-align center

        .certain {
          cursor pointer
          display inline-block
          width 10px
          height 10px
          outline 1px solid #e0e0e0
          border 3px solid #ffffff
        }
      }
    }

    .desc, .event {
      margin-top 20px

      .t_btn-d {
        width 80px
        height 30px
        margin-right 10px
      }
    }

    .event {
      text-align center
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/order.vue